<div class="sd-wrap" *ngIf="shots?.length">
  <button type="button" class="sd-btn sd-prev" (click)="prev()" aria-label="Previous Screenshot" title="Previous Screenshot">
    <app-icon name="chevron-left"></app-icon>
  </button>
  <div class="sd-deck" role="group" aria-roledescription="carousel" aria-label="Screenshots">
    <figure *ngFor="let s of shots; let i = index"
            class="sd-card"
            [attr.data-pos]="pos( i )"
            [class.sd-fading]="i === fading"
            [attr.aria-hidden]="pos( i ) !== 0"
            (click)="pos( i ) === 0 && next()">
      <img [src]="s.src" [alt]="s.alt" width="1200" height="787" decoding="async" draggable="false">
    </figure>
  </div>
  <button type="button" class="sd-btn sd-next" (click)="next()" aria-label="Next Screenshot" title="Next Screenshot">
    <app-icon name="chevron-right"></app-icon>
  </button>
  <div class="sd-meta">
    <span class="sd-name" aria-live="polite">
      <img *ngIf="logo( shots[ front ].caption ) as src" class="sd-logo" [src]="src" alt="" width="20" height="20">
      {{ shots[ front ].caption }}
    </span>
    <span class="sd-dots">
      <button type="button" *ngFor="let s of shots; let i = index" class="sd-dot"
              [class.sd-dot-on]="i === front" (click)="show( i )"
              [attr.aria-label]="'Show ' + s.caption" [attr.aria-pressed]="i === front"></button>
    </span>
  </div>
</div>
